export const MockCongressionalDistricts = [
  {
    fips: "01",
    name: "Congressional District 01",
    state: "Alabama",
  },
  {
    fips: "02",
    name: "Congressional District 02",
    state: "Alabama",
  },
  {
    fips: "03",
    name: "Congressional District 03",
    state: "Alabama",
  },
  {
    fips: "04",
    name: "Congressional District 04",
    state: "Alabama",
  },
  {
    fips: "05",
    name: "Congressional District 05",
    state: "Alabama",
  },
  {
    fips: "06",
    name: "Congressional District 06",
    state: "Alabama",
  },
  {
    fips: "07",
    name: "Congressional District 07",
    state: "Alabama",
  },
  {
    fips: "00",
    name: "Congressional District 00",
    state: "Alaska",
  },
  {
    fips: "01",
    name: "Congressional District 01",
    state: "Arizona",
  },
  {
    fips: "02",
    name: "Congressional District 02",
    state: "Arizona",
  },
  {
    fips: "03",
    name: "Congressional District 03",
    state: "Arizona",
  },
  {
    fips: "04",
    name: "Congressional District 04",
    state: "Arizona",
  },
  {
    fips: "05",
    name: "Congressional District 05",
    state: "Arizona",
  },
  {
    fips: "06",
    name: "Congressional District 06",
    state: "Arizona",
  },
  {
    fips: "07",
    name: "Congressional District 07",
    state: "Arizona",
  },
  {
    fips: "08",
    name: "Congressional District 08",
    state: "Arizona",
  },
  {
    fips: "09",
    name: "Congressional District 09",
    state: "Arizona",
  },
  {
    fips: "01",
    name: "Congressional District 01",
    state: "Arkansas",
  },
  {
    fips: "02",
    name: "Congressional District 02",
    state: "Arkansas",
  },
  {
    fips: "03",
    name: "Congressional District 03",
    state: "Arkansas",
  },
  {
    fips: "04",
    name: "Congressional District 04",
    state: "Arkansas",
  },
  {
    fips: "01",
    name: "Congressional District 01",
    state: "California",
  },
  {
    fips: "02",
    name: "Congressional District 02",
    state: "California",
  },
  {
    fips: "03",
    name: "Congressional District 03",
    state: "California",
  },
  {
    fips: "04",
    name: "Congressional District 04",
    state: "California",
  },
  {
    fips: "05",
    name: "Congressional District 05",
    state: "California",
  },
  {
    fips: "06",
    name: "Congressional District 06",
    state: "California",
  },
  {
    fips: "07",
    name: "Congressional District 07",
    state: "California",
  },
  {
    fips: "08",
    name: "Congressional District 08",
    state: "California",
  },
  {
    fips: "09",
    name: "Congressional District 09",
    state: "California",
  },
  {
    fips: "10",
    name: "Congressional District 10",
    state: "California",
  },
  {
    fips: "11",
    name: "Congressional District 11",
    state: "California",
  },
  {
    fips: "12",
    name: "Congressional District 12",
    state: "California",
  },
  {
    fips: "13",
    name: "Congressional District 13",
    state: "California",
  },
  {
    fips: "14",
    name: "Congressional District 14",
    state: "California",
  },
  {
    fips: "15",
    name: "Congressional District 15",
    state: "California",
  },
  {
    fips: "16",
    name: "Congressional District 16",
    state: "California",
  },
  {
    fips: "17",
    name: "Congressional District 17",
    state: "California",
  },
  {
    fips: "18",
    name: "Congressional District 18",
    state: "California",
  },
  {
    fips: "19",
    name: "Congressional District 19",
    state: "California",
  },
  {
    fips: "20",
    name: "Congressional District 20",
    state: "California",
  },
  {
    fips: "21",
    name: "Congressional District 21",
    state: "California",
  },
  {
    fips: "22",
    name: "Congressional District 22",
    state: "California",
  },
  {
    fips: "23",
    name: "Congressional District 23",
    state: "California",
  },
  {
    fips: "24",
    name: "Congressional District 24",
    state: "California",
  },
  {
    fips: "25",
    name: "Congressional District 25",
    state: "California",
  },
  {
    fips: "26",
    name: "Congressional District 26",
    state: "California",
  },
  {
    fips: "27",
    name: "Congressional District 27",
    state: "California",
  },
  {
    fips: "28",
    name: "Congressional District 28",
    state: "California",
  },
  {
    fips: "29",
    name: "Congressional District 29",
    state: "California",
  },
  {
    fips: "30",
    name: "Congressional District 30",
    state: "California",
  },
  {
    fips: "31",
    name: "Congressional District 31",
    state: "California",
  },
  {
    fips: "32",
    name: "Congressional District 32",
    state: "California",
  },
  {
    fips: "33",
    name: "Congressional District 33",
    state: "California",
  },
  {
    fips: "34",
    name: "Congressional District 34",
    state: "California",
  },
  {
    fips: "35",
    name: "Congressional District 35",
    state: "California",
  },
  {
    fips: "36",
    name: "Congressional District 36",
    state: "California",
  },
  {
    fips: "37",
    name: "Congressional District 37",
    state: "California",
  },
  {
    fips: "38",
    name: "Congressional District 38",
    state: "California",
  },
  {
    fips: "39",
    name: "Congressional District 39",
    state: "California",
  },
  {
    fips: "40",
    name: "Congressional District 40",
    state: "California",
  },
  {
    fips: "41",
    name: "Congressional District 41",
    state: "California",
  },
  {
    fips: "42",
    name: "Congressional District 42",
    state: "California",
  },
  {
    fips: "43",
    name: "Congressional District 43",
    state: "California",
  },
  {
    fips: "44",
    name: "Congressional District 44",
    state: "California",
  },
  {
    fips: "45",
    name: "Congressional District 45",
    state: "California",
  },
  {
    fips: "46",
    name: "Congressional District 46",
    state: "California",
  },
  {
    fips: "47",
    name: "Congressional District 47",
    state: "California",
  },
  {
    fips: "48",
    name: "Congressional District 48",
    state: "California",
  },
  {
    fips: "49",
    name: "Congressional District 49",
    state: "California",
  },
  {
    fips: "50",
    name: "Congressional District 50",
    state: "California",
  },
  {
    fips: "51",
    name: "Congressional District 51",
    state: "California",
  },
  {
    fips: "52",
    name: "Congressional District 52",
    state: "California",
  },
  {
    fips: "53",
    name: "Congressional District 53",
    state: "California",
  },
  {
    fips: "01",
    name: "Congressional District 01",
    state: "Colorado",
  },
  {
    fips: "02",
    name: "Congressional District 02",
    state: "Colorado",
  },
  {
    fips: "03",
    name: "Congressional District 03",
    state: "Colorado",
  },
  {
    fips: "04",
    name: "Congressional District 04",
    state: "Colorado",
  },
  {
    fips: "05",
    name: "Congressional District 05",
    state: "Colorado",
  },
  {
    fips: "06",
    name: "Congressional District 06",
    state: "Colorado",
  },
  {
    fips: "07",
    name: "Congressional District 07",
    state: "Colorado",
  },
  {
    fips: "08",
    name: "Congressional District 08",
    state: "Colorado",
  },
  {
    fips: "01",
    name: "Congressional District 01",
    state: "Connecticut",
  },
  {
    fips: "02",
    name: "Congressional District 02",
    state: "Connecticut",
  },
  {
    fips: "03",
    name: "Congressional District 03",
    state: "Connecticut",
  },
  {
    fips: "04",
    name: "Congressional District 04",
    state: "Connecticut",
  },
  {
    fips: "05",
    name: "Congressional District 05",
    state: "Connecticut",
  },
  {
    fips: "00",
    name: "Congressional District 00",
    state: "Delaware",
  },
  {
    fips: "01",
    name: "Congressional District 01",
    state: "Florida",
  },
  {
    fips: "02",
    name: "Congressional District 02",
    state: "Florida",
  },
  {
    fips: "03",
    name: "Congressional District 03",
    state: "Florida",
  },
  {
    fips: "04",
    name: "Congressional District 04",
    state: "Florida",
  },
  {
    fips: "05",
    name: "Congressional District 05",
    state: "Florida",
  },
  {
    fips: "06",
    name: "Congressional District 06",
    state: "Florida",
  },
  {
    fips: "07",
    name: "Congressional District 07",
    state: "Florida",
  },
  {
    fips: "08",
    name: "Congressional District 08",
    state: "Florida",
  },
  {
    fips: "09",
    name: "Congressional District 09",
    state: "Florida",
  },
  {
    fips: "10",
    name: "Congressional District 10",
    state: "Florida",
  },
  {
    fips: "11",
    name: "Congressional District 11",
    state: "Florida",
  },
  {
    fips: "12",
    name: "Congressional District 12",
    state: "Florida",
  },
  {
    fips: "13",
    name: "Congressional District 13",
    state: "Florida",
  },
  {
    fips: "14",
    name: "Congressional District 14",
    state: "Florida",
  },
  {
    fips: "15",
    name: "Congressional District 15",
    state: "Florida",
  },
  {
    fips: "16",
    name: "Congressional District 16",
    state: "Florida",
  },
  {
    fips: "17",
    name: "Congressional District 17",
    state: "Florida",
  },
  {
    fips: "18",
    name: "Congressional District 18",
    state: "Florida",
  },
  {
    fips: "19",
    name: "Congressional District 19",
    state: "Florida",
  },
  {
    fips: "20",
    name: "Congressional District 20",
    state: "Florida",
  },
  {
    fips: "21",
    name: "Congressional District 21",
    state: "Florida",
  },
  {
    fips: "22",
    name: "Congressional District 22",
    state: "Florida",
  },
  {
    fips: "23",
    name: "Congressional District 23",
    state: "Florida",
  },
  {
    fips: "24",
    name: "Congressional District 24",
    state: "Florida",
  },
  {
    fips: "25",
    name: "Congressional District 25",
    state: "Florida",
  },
  {
    fips: "26",
    name: "Congressional District 26",
    state: "Florida",
  },
  {
    fips: "27",
    name: "Congressional District 27",
    state: "Florida",
  },
  {
    fips: "28",
    name: "Congressional District 28",
    state: "Florida",
  },
  {
    fips: "01",
    name: "Congressional District 01",
    state: "Georgia",
  },
  {
    fips: "02",
    name: "Congressional District 02",
    state: "Georgia",
  },
  {
    fips: "03",
    name: "Congressional District 03",
    state: "Georgia",
  },
  {
    fips: "04",
    name: "Congressional District 04",
    state: "Georgia",
  },
  {
    fips: "05",
    name: "Congressional District 05",
    state: "Georgia",
  },
  {
    fips: "06",
    name: "Congressional District 06",
    state: "Georgia",
  },
  {
    fips: "07",
    name: "Congressional District 07",
    state: "Georgia",
  },
  {
    fips: "08",
    name: "Congressional District 08",
    state: "Georgia",
  },
  {
    fips: "09",
    name: "Congressional District 09",
    state: "Georgia",
  },
  {
    fips: "10",
    name: "Congressional District 10",
    state: "Georgia",
  },
  {
    fips: "11",
    name: "Congressional District 11",
    state: "Georgia",
  },
  {
    fips: "12",
    name: "Congressional District 12",
    state: "Georgia",
  },
  {
    fips: "13",
    name: "Congressional District 13",
    state: "Georgia",
  },
  {
    fips: "14",
    name: "Congressional District 14",
    state: "Georgia",
  },
  {
    fips: "01",
    name: "Congressional District 01",
    state: "Hawaii",
  },
  {
    fips: "02",
    name: "Congressional District 02",
    state: "Hawaii",
  },
  {
    fips: "01",
    name: "Congressional District 01",
    state: "Idaho",
  },
  {
    fips: "02",
    name: "Congressional District 02",
    state: "Idaho",
  },
  {
    fips: "01",
    name: "Congressional District 01",
    state: "Illinois",
  },
  {
    fips: "02",
    name: "Congressional District 02",
    state: "Illinois",
  },
  {
    fips: "03",
    name: "Congressional District 03",
    state: "Illinois",
  },
  {
    fips: "04",
    name: "Congressional District 04",
    state: "Illinois",
  },
  {
    fips: "05",
    name: "Congressional District 05",
    state: "Illinois",
  },
  {
    fips: "06",
    name: "Congressional District 06",
    state: "Illinois",
  },
  {
    fips: "07",
    name: "Congressional District 07",
    state: "Illinois",
  },
  {
    fips: "08",
    name: "Congressional District 08",
    state: "Illinois",
  },
  {
    fips: "09",
    name: "Congressional District 09",
    state: "Illinois",
  },
  {
    fips: "10",
    name: "Congressional District 10",
    state: "Illinois",
  },
  {
    fips: "11",
    name: "Congressional District 11",
    state: "Illinois",
  },
  {
    fips: "12",
    name: "Congressional District 12",
    state: "Illinois",
  },
  {
    fips: "13",
    name: "Congressional District 13",
    state: "Illinois",
  },
  {
    fips: "14",
    name: "Congressional District 14",
    state: "Illinois",
  },
  {
    fips: "15",
    name: "Congressional District 15",
    state: "Illinois",
  },
  {
    fips: "16",
    name: "Congressional District 16",
    state: "Illinois",
  },
  {
    fips: "17",
    name: "Congressional District 17",
    state: "Illinois",
  },
  {
    fips: "01",
    name: "Congressional District 01",
    state: "Indiana",
  },
  {
    fips: "02",
    name: "Congressional District 02",
    state: "Indiana",
  },
  {
    fips: "03",
    name: "Congressional District 03",
    state: "Indiana",
  },
  {
    fips: "04",
    name: "Congressional District 04",
    state: "Indiana",
  },
  {
    fips: "05",
    name: "Congressional District 05",
    state: "Indiana",
  },
  {
    fips: "06",
    name: "Congressional District 06",
    state: "Indiana",
  },
  {
    fips: "07",
    name: "Congressional District 07",
    state: "Indiana",
  },
  {
    fips: "08",
    name: "Congressional District 08",
    state: "Indiana",
  },
  {
    fips: "09",
    name: "Congressional District 09",
    state: "Indiana",
  },
  {
    fips: "01",
    name: "Congressional District 01",
    state: "Iowa",
  },
  {
    fips: "02",
    name: "Congressional District 02",
    state: "Iowa",
  },
  {
    fips: "03",
    name: "Congressional District 03",
    state: "Iowa",
  },
  {
    fips: "04",
    name: "Congressional District 04",
    state: "Iowa",
  },
  {
    fips: "01",
    name: "Congressional District 01",
    state: "Kansas",
  },
  {
    fips: "02",
    name: "Congressional District 02",
    state: "Kansas",
  },
  {
    fips: "03",
    name: "Congressional District 03",
    state: "Kansas",
  },
  {
    fips: "04",
    name: "Congressional District 04",
    state: "Kansas",
  },
  {
    fips: "01",
    name: "Congressional District 01",
    state: "Kentucky",
  },
  {
    fips: "02",
    name: "Congressional District 02",
    state: "Kentucky",
  },
  {
    fips: "03",
    name: "Congressional District 03",
    state: "Kentucky",
  },
  {
    fips: "04",
    name: "Congressional District 04",
    state: "Kentucky",
  },
  {
    fips: "05",
    name: "Congressional District 05",
    state: "Kentucky",
  },
  {
    fips: "06",
    name: "Congressional District 06",
    state: "Kentucky",
  },
  {
    fips: "01",
    name: "Congressional District 01",
    state: "Louisiana",
  },
  {
    fips: "02",
    name: "Congressional District 02",
    state: "Louisiana",
  },
  {
    fips: "03",
    name: "Congressional District 03",
    state: "Louisiana",
  },
  {
    fips: "04",
    name: "Congressional District 04",
    state: "Louisiana",
  },
  {
    fips: "05",
    name: "Congressional District 05",
    state: "Louisiana",
  },
  {
    fips: "06",
    name: "Congressional District 06",
    state: "Louisiana",
  },
  {
    fips: "01",
    name: "Congressional District 01",
    state: "Maine",
  },
  {
    fips: "02",
    name: "Congressional District 02",
    state: "Maine",
  },
  {
    fips: "01",
    name: "Congressional District 01",
    state: "Maryland",
  },
  {
    fips: "02",
    name: "Congressional District 02",
    state: "Maryland",
  },
  {
    fips: "03",
    name: "Congressional District 03",
    state: "Maryland",
  },
  {
    fips: "04",
    name: "Congressional District 04",
    state: "Maryland",
  },
  {
    fips: "05",
    name: "Congressional District 05",
    state: "Maryland",
  },
  {
    fips: "06",
    name: "Congressional District 06",
    state: "Maryland",
  },
  {
    fips: "07",
    name: "Congressional District 07",
    state: "Maryland",
  },
  {
    fips: "08",
    name: "Congressional District 08",
    state: "Maryland",
  },
  {
    fips: "01",
    name: "Congressional District 01",
    state: "Massachusetts",
  },
  {
    fips: "02",
    name: "Congressional District 02",
    state: "Massachusetts",
  },
  {
    fips: "03",
    name: "Congressional District 03",
    state: "Massachusetts",
  },
  {
    fips: "04",
    name: "Congressional District 04",
    state: "Massachusetts",
  },
  {
    fips: "05",
    name: "Congressional District 05",
    state: "Massachusetts",
  },
  {
    fips: "06",
    name: "Congressional District 06",
    state: "Massachusetts",
  },
  {
    fips: "07",
    name: "Congressional District 07",
    state: "Massachusetts",
  },
  {
    fips: "08",
    name: "Congressional District 08",
    state: "Massachusetts",
  },
  {
    fips: "09",
    name: "Congressional District 09",
    state: "Massachusetts",
  },
  {
    fips: "01",
    name: "Congressional District 01",
    state: "Michigan",
  },
  {
    fips: "02",
    name: "Congressional District 02",
    state: "Michigan",
  },
  {
    fips: "03",
    name: "Congressional District 03",
    state: "Michigan",
  },
  {
    fips: "04",
    name: "Congressional District 04",
    state: "Michigan",
  },
  {
    fips: "05",
    name: "Congressional District 05",
    state: "Michigan",
  },
  {
    fips: "06",
    name: "Congressional District 06",
    state: "Michigan",
  },
  {
    fips: "07",
    name: "Congressional District 07",
    state: "Michigan",
  },
  {
    fips: "08",
    name: "Congressional District 08",
    state: "Michigan",
  },
  {
    fips: "09",
    name: "Congressional District 09",
    state: "Michigan",
  },
  {
    fips: "10",
    name: "Congressional District 10",
    state: "Michigan",
  },
  {
    fips: "11",
    name: "Congressional District 11",
    state: "Michigan",
  },
  {
    fips: "12",
    name: "Congressional District 12",
    state: "Michigan",
  },
  {
    fips: "13",
    name: "Congressional District 13",
    state: "Michigan",
  },
  {
    fips: "01",
    name: "Congressional District 01",
    state: "Minnesota",
  },
  {
    fips: "02",
    name: "Congressional District 02",
    state: "Minnesota",
  },
  {
    fips: "03",
    name: "Congressional District 03",
    state: "Minnesota",
  },
  {
    fips: "04",
    name: "Congressional District 04",
    state: "Minnesota",
  },
  {
    fips: "05",
    name: "Congressional District 05",
    state: "Minnesota",
  },
  {
    fips: "06",
    name: "Congressional District 06",
    state: "Minnesota",
  },
  {
    fips: "07",
    name: "Congressional District 07",
    state: "Minnesota",
  },
  {
    fips: "08",
    name: "Congressional District 08",
    state: "Minnesota",
  },
  {
    fips: "01",
    name: "Congressional District 01",
    state: "Mississippi",
  },
  {
    fips: "02",
    name: "Congressional District 02",
    state: "Mississippi",
  },
  {
    fips: "03",
    name: "Congressional District 03",
    state: "Mississippi",
  },
  {
    fips: "04",
    name: "Congressional District 04",
    state: "Mississippi",
  },
  {
    fips: "01",
    name: "Congressional District 01",
    state: "Missouri",
  },
  {
    fips: "02",
    name: "Congressional District 02",
    state: "Missouri",
  },
  {
    fips: "03",
    name: "Congressional District 03",
    state: "Missouri",
  },
  {
    fips: "04",
    name: "Congressional District 04",
    state: "Missouri",
  },
  {
    fips: "05",
    name: "Congressional District 05",
    state: "Missouri",
  },
  {
    fips: "06",
    name: "Congressional District 06",
    state: "Missouri",
  },
  {
    fips: "07",
    name: "Congressional District 07",
    state: "Missouri",
  },
  {
    fips: "08",
    name: "Congressional District 08",
    state: "Missouri",
  },
  {
    fips: "01",
    name: "Congressional District 01",
    state: "Montana",
  },
  {
    fips: "02",
    name: "Congressional District 02",
    state: "Montana",
  },
  {
    fips: "01",
    name: "Congressional District 01",
    state: "Nebraska",
  },
  {
    fips: "02",
    name: "Congressional District 02",
    state: "Nebraska",
  },
  {
    fips: "03",
    name: "Congressional District 03",
    state: "Nebraska",
  },
  {
    fips: "01",
    name: "Congressional District 01",
    state: "Nevada",
  },
  {
    fips: "02",
    name: "Congressional District 02",
    state: "Nevada",
  },
  {
    fips: "03",
    name: "Congressional District 03",
    state: "Nevada",
  },
  {
    fips: "04",
    name: "Congressional District 04",
    state: "Nevada",
  },
  {
    fips: "01",
    name: "Congressional District 01",
    state: "New Hampshire",
  },
  {
    fips: "02",
    name: "Congressional District 02",
    state: "New Hampshire",
  },
  {
    fips: "01",
    name: "Congressional District 01",
    state: "New Jersey",
  },
  {
    fips: "02",
    name: "Congressional District 02",
    state: "New Jersey",
  },
  {
    fips: "03",
    name: "Congressional District 03",
    state: "New Jersey",
  },
  {
    fips: "04",
    name: "Congressional District 04",
    state: "New Jersey",
  },
  {
    fips: "05",
    name: "Congressional District 05",
    state: "New Jersey",
  },
  {
    fips: "06",
    name: "Congressional District 06",
    state: "New Jersey",
  },
  {
    fips: "07",
    name: "Congressional District 07",
    state: "New Jersey",
  },
  {
    fips: "08",
    name: "Congressional District 08",
    state: "New Jersey",
  },
  {
    fips: "09",
    name: "Congressional District 09",
    state: "New Jersey",
  },
  {
    fips: "10",
    name: "Congressional District 10",
    state: "New Jersey",
  },
  {
    fips: "11",
    name: "Congressional District 11",
    state: "New Jersey",
  },
  {
    fips: "12",
    name: "Congressional District 12",
    state: "New Jersey",
  },
  {
    fips: "01",
    name: "Congressional District 01",
    state: "New Mexico",
  },
  {
    fips: "02",
    name: "Congressional District 02",
    state: "New Mexico",
  },
  {
    fips: "03",
    name: "Congressional District 03",
    state: "New Mexico",
  },
  {
    fips: "01",
    name: "Congressional District 01",
    state: "New York",
  },
  {
    fips: "02",
    name: "Congressional District 02",
    state: "New York",
  },
  {
    fips: "03",
    name: "Congressional District 03",
    state: "New York",
  },
  {
    fips: "04",
    name: "Congressional District 04",
    state: "New York",
  },
  {
    fips: "05",
    name: "Congressional District 05",
    state: "New York",
  },
  {
    fips: "06",
    name: "Congressional District 06",
    state: "New York",
  },
  {
    fips: "07",
    name: "Congressional District 07",
    state: "New York",
  },
  {
    fips: "08",
    name: "Congressional District 08",
    state: "New York",
  },
  {
    fips: "09",
    name: "Congressional District 09",
    state: "New York",
  },
  {
    fips: "10",
    name: "Congressional District 10",
    state: "New York",
  },
  {
    fips: "11",
    name: "Congressional District 11",
    state: "New York",
  },
  {
    fips: "12",
    name: "Congressional District 12",
    state: "New York",
  },
  {
    fips: "13",
    name: "Congressional District 13",
    state: "New York",
  },
  {
    fips: "14",
    name: "Congressional District 14",
    state: "New York",
  },
  {
    fips: "15",
    name: "Congressional District 15",
    state: "New York",
  },
  {
    fips: "16",
    name: "Congressional District 16",
    state: "New York",
  },
  {
    fips: "17",
    name: "Congressional District 17",
    state: "New York",
  },
  {
    fips: "18",
    name: "Congressional District 18",
    state: "New York",
  },
  {
    fips: "19",
    name: "Congressional District 19",
    state: "New York",
  },
  {
    fips: "20",
    name: "Congressional District 20",
    state: "New York",
  },
  {
    fips: "21",
    name: "Congressional District 21",
    state: "New York",
  },
  {
    fips: "22",
    name: "Congressional District 22",
    state: "New York",
  },
  {
    fips: "23",
    name: "Congressional District 23",
    state: "New York",
  },
  {
    fips: "24",
    name: "Congressional District 24",
    state: "New York",
  },
  {
    fips: "25",
    name: "Congressional District 25",
    state: "New York",
  },
  {
    fips: "26",
    name: "Congressional District 26",
    state: "New York",
  },
  {
    fips: "01",
    name: "Congressional District 01",
    state: "North Carolina",
  },
  {
    fips: "02",
    name: "Congressional District 02",
    state: "North Carolina",
  },
  {
    fips: "03",
    name: "Congressional District 03",
    state: "North Carolina",
  },
  {
    fips: "04",
    name: "Congressional District 04",
    state: "North Carolina",
  },
  {
    fips: "05",
    name: "Congressional District 05",
    state: "North Carolina",
  },
  {
    fips: "06",
    name: "Congressional District 06",
    state: "North Carolina",
  },
  {
    fips: "07",
    name: "Congressional District 07",
    state: "North Carolina",
  },
  {
    fips: "08",
    name: "Congressional District 08",
    state: "North Carolina",
  },
  {
    fips: "09",
    name: "Congressional District 09",
    state: "North Carolina",
  },
  {
    fips: "10",
    name: "Congressional District 10",
    state: "North Carolina",
  },
  {
    fips: "11",
    name: "Congressional District 11",
    state: "North Carolina",
  },
  {
    fips: "12",
    name: "Congressional District 12",
    state: "North Carolina",
  },
  {
    fips: "13",
    name: "Congressional District 13",
    state: "North Carolina",
  },
  {
    fips: "14",
    name: "Congressional District 14",
    state: "North Carolina",
  },
  {
    fips: "00",
    name: "Congressional District 00",
    state: "North Dakota",
  },
  {
    fips: "01",
    name: "Congressional District 01",
    state: "Ohio",
  },
  {
    fips: "02",
    name: "Congressional District 02",
    state: "Ohio",
  },
  {
    fips: "03",
    name: "Congressional District 03",
    state: "Ohio",
  },
  {
    fips: "04",
    name: "Congressional District 04",
    state: "Ohio",
  },
  {
    fips: "05",
    name: "Congressional District 05",
    state: "Ohio",
  },
  {
    fips: "06",
    name: "Congressional District 06",
    state: "Ohio",
  },
  {
    fips: "07",
    name: "Congressional District 07",
    state: "Ohio",
  },
  {
    fips: "08",
    name: "Congressional District 08",
    state: "Ohio",
  },
  {
    fips: "09",
    name: "Congressional District 09",
    state: "Ohio",
  },
  {
    fips: "10",
    name: "Congressional District 10",
    state: "Ohio",
  },
  {
    fips: "11",
    name: "Congressional District 11",
    state: "Ohio",
  },
  {
    fips: "12",
    name: "Congressional District 12",
    state: "Ohio",
  },
  {
    fips: "13",
    name: "Congressional District 13",
    state: "Ohio",
  },
  {
    fips: "14",
    name: "Congressional District 14",
    state: "Ohio",
  },
  {
    fips: "15",
    name: "Congressional District 15",
    state: "Ohio",
  },
  {
    fips: "01",
    name: "Congressional District 01",
    state: "Oklahoma",
  },
  {
    fips: "02",
    name: "Congressional District 02",
    state: "Oklahoma",
  },
  {
    fips: "03",
    name: "Congressional District 03",
    state: "Oklahoma",
  },
  {
    fips: "04",
    name: "Congressional District 04",
    state: "Oklahoma",
  },
  {
    fips: "05",
    name: "Congressional District 05",
    state: "Oklahoma",
  },
  {
    fips: "01",
    name: "Congressional District 01",
    state: "Oregon",
  },
  {
    fips: "02",
    name: "Congressional District 02",
    state: "Oregon",
  },
  {
    fips: "03",
    name: "Congressional District 03",
    state: "Oregon",
  },
  {
    fips: "04",
    name: "Congressional District 04",
    state: "Oregon",
  },
  {
    fips: "05",
    name: "Congressional District 05",
    state: "Oregon",
  },
  {
    fips: "06",
    name: "Congressional District 06",
    state: "Oregon",
  },
  {
    fips: "01",
    name: "Congressional District 01",
    state: "Pennsylvania",
  },
  {
    fips: "02",
    name: "Congressional District 02",
    state: "Pennsylvania",
  },
  {
    fips: "03",
    name: "Congressional District 03",
    state: "Pennsylvania",
  },
  {
    fips: "04",
    name: "Congressional District 04",
    state: "Pennsylvania",
  },
  {
    fips: "05",
    name: "Congressional District 05",
    state: "Pennsylvania",
  },
  {
    fips: "06",
    name: "Congressional District 06",
    state: "Pennsylvania",
  },
  {
    fips: "07",
    name: "Congressional District 07",
    state: "Pennsylvania",
  },
  {
    fips: "08",
    name: "Congressional District 08",
    state: "Pennsylvania",
  },
  {
    fips: "09",
    name: "Congressional District 09",
    state: "Pennsylvania",
  },
  {
    fips: "10",
    name: "Congressional District 10",
    state: "Pennsylvania",
  },
  {
    fips: "11",
    name: "Congressional District 11",
    state: "Pennsylvania",
  },
  {
    fips: "12",
    name: "Congressional District 12",
    state: "Pennsylvania",
  },
  {
    fips: "13",
    name: "Congressional District 13",
    state: "Pennsylvania",
  },
  {
    fips: "14",
    name: "Congressional District 14",
    state: "Pennsylvania",
  },
  {
    fips: "15",
    name: "Congressional District 15",
    state: "Pennsylvania",
  },
  {
    fips: "16",
    name: "Congressional District 16",
    state: "Pennsylvania",
  },
  {
    fips: "17",
    name: "Congressional District 17",
    state: "Pennsylvania",
  },
  {
    fips: "01",
    name: "Congressional District 01",
    state: "Rhode Island",
  },
  {
    fips: "02",
    name: "Congressional District 02",
    state: "Rhode Island",
  },
  {
    fips: "01",
    name: "Congressional District 01",
    state: "South Carolina",
  },
  {
    fips: "02",
    name: "Congressional District 02",
    state: "South Carolina",
  },
  {
    fips: "03",
    name: "Congressional District 03",
    state: "South Carolina",
  },
  {
    fips: "04",
    name: "Congressional District 04",
    state: "South Carolina",
  },
  {
    fips: "05",
    name: "Congressional District 05",
    state: "South Carolina",
  },
  {
    fips: "06",
    name: "Congressional District 06",
    state: "South Carolina",
  },
  {
    fips: "07",
    name: "Congressional District 07",
    state: "South Carolina",
  },
  {
    fips: "00",
    name: "Congressional District 00",
    state: "South Dakota",
  },
  {
    fips: "01",
    name: "Congressional District 01",
    state: "Tennessee",
  },
  {
    fips: "02",
    name: "Congressional District 02",
    state: "Tennessee",
  },
  {
    fips: "03",
    name: "Congressional District 03",
    state: "Tennessee",
  },
  {
    fips: "04",
    name: "Congressional District 04",
    state: "Tennessee",
  },
  {
    fips: "05",
    name: "Congressional District 05",
    state: "Tennessee",
  },
  {
    fips: "06",
    name: "Congressional District 06",
    state: "Tennessee",
  },
  {
    fips: "07",
    name: "Congressional District 07",
    state: "Tennessee",
  },
  {
    fips: "08",
    name: "Congressional District 08",
    state: "Tennessee",
  },
  {
    fips: "09",
    name: "Congressional District 09",
    state: "Tennessee",
  },
  {
    fips: "01",
    name: "Congressional District 01",
    state: "Texas",
  },
  {
    fips: "02",
    name: "Congressional District 02",
    state: "Texas",
  },
  {
    fips: "03",
    name: "Congressional District 03",
    state: "Texas",
  },
  {
    fips: "04",
    name: "Congressional District 04",
    state: "Texas",
  },
  {
    fips: "05",
    name: "Congressional District 05",
    state: "Texas",
  },
  {
    fips: "06",
    name: "Congressional District 06",
    state: "Texas",
  },
  {
    fips: "07",
    name: "Congressional District 07",
    state: "Texas",
  },
  {
    fips: "08",
    name: "Congressional District 08",
    state: "Texas",
  },
  {
    fips: "09",
    name: "Congressional District 09",
    state: "Texas",
  },
  {
    fips: "10",
    name: "Congressional District 10",
    state: "Texas",
  },
  {
    fips: "11",
    name: "Congressional District 11",
    state: "Texas",
  },
  {
    fips: "12",
    name: "Congressional District 12",
    state: "Texas",
  },
  {
    fips: "13",
    name: "Congressional District 13",
    state: "Texas",
  },
  {
    fips: "14",
    name: "Congressional District 14",
    state: "Texas",
  },
  {
    fips: "15",
    name: "Congressional District 15",
    state: "Texas",
  },
  {
    fips: "16",
    name: "Congressional District 16",
    state: "Texas",
  },
  {
    fips: "17",
    name: "Congressional District 17",
    state: "Texas",
  },
  {
    fips: "18",
    name: "Congressional District 18",
    state: "Texas",
  },
  {
    fips: "19",
    name: "Congressional District 19",
    state: "Texas",
  },
  {
    fips: "20",
    name: "Congressional District 20",
    state: "Texas",
  },
  {
    fips: "21",
    name: "Congressional District 21",
    state: "Texas",
  },
  {
    fips: "22",
    name: "Congressional District 22",
    state: "Texas",
  },
  {
    fips: "23",
    name: "Congressional District 23",
    state: "Texas",
  },
  {
    fips: "24",
    name: "Congressional District 24",
    state: "Texas",
  },
  {
    fips: "25",
    name: "Congressional District 25",
    state: "Texas",
  },
  {
    fips: "26",
    name: "Congressional District 26",
    state: "Texas",
  },
  {
    fips: "27",
    name: "Congressional District 27",
    state: "Texas",
  },
  {
    fips: "28",
    name: "Congressional District 28",
    state: "Texas",
  },
  {
    fips: "29",
    name: "Congressional District 29",
    state: "Texas",
  },
  {
    fips: "30",
    name: "Congressional District 30",
    state: "Texas",
  },
  {
    fips: "31",
    name: "Congressional District 31",
    state: "Texas",
  },
  {
    fips: "32",
    name: "Congressional District 32",
    state: "Texas",
  },
  {
    fips: "33",
    name: "Congressional District 33",
    state: "Texas",
  },
  {
    fips: "34",
    name: "Congressional District 34",
    state: "Texas",
  },
  {
    fips: "35",
    name: "Congressional District 35",
    state: "Texas",
  },
  {
    fips: "36",
    name: "Congressional District 36",
    state: "Texas",
  },
  {
    fips: "37",
    name: "Congressional District 37",
    state: "Texas",
  },
  {
    fips: "38",
    name: "Congressional District 38",
    state: "Texas",
  },
  {
    fips: "01",
    name: "Congressional District 01",
    state: "Utah",
  },
  {
    fips: "02",
    name: "Congressional District 02",
    state: "Utah",
  },
  {
    fips: "03",
    name: "Congressional District 03",
    state: "Utah",
  },
  {
    fips: "04",
    name: "Congressional District 04",
    state: "Utah",
  },
  {
    fips: "00",
    name: "Congressional District 00",
    state: "Vermont",
  },
  {
    fips: "01",
    name: "Congressional District 01",
    state: "Virginia",
  },
  {
    fips: "02",
    name: "Congressional District 02",
    state: "Virginia",
  },
  {
    fips: "03",
    name: "Congressional District 03",
    state: "Virginia",
  },
  {
    fips: "04",
    name: "Congressional District 04",
    state: "Virginia",
  },
  {
    fips: "05",
    name: "Congressional District 05",
    state: "Virginia",
  },
  {
    fips: "06",
    name: "Congressional District 06",
    state: "Virginia",
  },
  {
    fips: "07",
    name: "Congressional District 07",
    state: "Virginia",
  },
  {
    fips: "08",
    name: "Congressional District 08",
    state: "Virginia",
  },
  {
    fips: "09",
    name: "Congressional District 09",
    state: "Virginia",
  },
  {
    fips: "10",
    name: "Congressional District 10",
    state: "Virginia",
  },
  {
    fips: "11",
    name: "Congressional District 11",
    state: "Virginia",
  },
  {
    fips: "01",
    name: "Congressional District 01",
    state: "Washington",
  },
  {
    fips: "02",
    name: "Congressional District 02",
    state: "Washington",
  },
  {
    fips: "03",
    name: "Congressional District 03",
    state: "Washington",
  },
  {
    fips: "04",
    name: "Congressional District 04",
    state: "Washington",
  },
  {
    fips: "05",
    name: "Congressional District 05",
    state: "Washington",
  },
  {
    fips: "06",
    name: "Congressional District 06",
    state: "Washington",
  },
  {
    fips: "07",
    name: "Congressional District 07",
    state: "Washington",
  },
  {
    fips: "08",
    name: "Congressional District 08",
    state: "Washington",
  },
  {
    fips: "09",
    name: "Congressional District 09",
    state: "Washington",
  },
  {
    fips: "10",
    name: "Congressional District 10",
    state: "Washington",
  },
  {
    fips: "01",
    name: "Congressional District 01",
    state: "West Virginia",
  },
  {
    fips: "02",
    name: "Congressional District 02",
    state: "West Virginia",
  },
  {
    fips: "01",
    name: "Congressional District 01",
    state: "Wisconsin",
  },
  {
    fips: "02",
    name: "Congressional District 02",
    state: "Wisconsin",
  },
  {
    fips: "03",
    name: "Congressional District 03",
    state: "Wisconsin",
  },
  {
    fips: "04",
    name: "Congressional District 04",
    state: "Wisconsin",
  },
  {
    fips: "05",
    name: "Congressional District 05",
    state: "Wisconsin",
  },
  {
    fips: "06",
    name: "Congressional District 06",
    state: "Wisconsin",
  },
  {
    fips: "07",
    name: "Congressional District 07",
    state: "Wisconsin",
  },
  {
    fips: "08",
    name: "Congressional District 08",
    state: "Wisconsin",
  },
  {
    fips: "00",
    name: "Congressional District 00",
    state: "Wyoming",
  },
  {
    fips: "98",
    name: "Congressional District 98",
    state: "District of Columbia",
  },
  {
    fips: "98",
    name: "Congressional District 98",
    state: "American Samoa",
  },
  {
    fips: "98",
    name: "Congressional District 98",
    state: "Guam",
  },
  {
    fips: "98",
    name: "Congressional District 98",
    state: "Northern Mariana Islands",
  },
  {
    fips: "98",
    name: "Congressional District 98",
    state: "Puerto Rico",
  },
  {
    fips: "98",
    name: "Congressional District 98",
    state: "U.S. Virgin Islands",
  },
];
